import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "topbar d-flex align-items-stretch flex-shrink-0" }
const _hoisted_3 = {
  class: "d-flex align-items-center me-n3 ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px btn-white",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/avatars/user-svgrepo-com.svg",
    alt: "metronic",
    class: "h-25px w-25px rounded"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_KTUserMenu)
      ])
    ])
  ]))
}